import React from "react";
import LeftServiceButtonImgSection1 from "./LeftServiceButtonImgSection1";

const LeftServiceButtonSection1 = (props) => {
  if(props.row === "top"){
  return (
    <div className="flex cursor-pointer justify-around mt-10 w-[100%]">
      <LeftServiceButtonImgSection1 image="https://static.toiimg.com/thumb/msid-75665075,width-400,resizemode-4/75665075.jpg"/>
      <LeftServiceButtonImgSection1 image="https://static.toiimg.com/thumb/imgsize-23456,msid-76740315,width-600,resizemode-4/76740315.jpg"/>
      <LeftServiceButtonImgSection1 image="https://educationtoday.co/wp-content/uploads/2022/11/News-Paper-740x1024.jpg"/>
    </div>
  );
} else {
  return (
    <div className="flex cursor-pointer justify-around mt-10">
      <LeftServiceButtonImgSection1 image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCNBYEM3cU5uC9wrgaDXRD5ofFxmExX0pBEw&usqp=CAU"/>
      <LeftServiceButtonImgSection1 image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcJs3lkqHXYLXcKXmcl0q3JDwRNtXpIgQSRBcvFnQQtsn110_82omch6Z6nkIm7pWOzIQ&usqp=CAU"/>
      <LeftServiceButtonImgSection1 image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcJs3lkqHXYLXcKXmcl0q3JDwRNtXpIgQSRBcvFnQQtsn110_82omch6Z6nkIm7pWOzIQ&usqp=CAU"/>
    </div>
  );
}
}
export default LeftServiceButtonSection1;
